import { render } from "./IRM.vue?vue&type=template&id=048164de&scoped=true"
import script from "./IRM.vue?vue&type=script&lang=js"
export * from "./IRM.vue?vue&type=script&lang=js"

import "./IRM.vue?vue&type=style&index=0&id=048164de&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048164de"]])

export default __exports__